export default __webpack_public_path__ + "static/media/profile.f7d3b665.jpg";